import styled from "react-emotion";
import {Label} from "bloomer";

const WordsLabel = styled(Label)`
  float: right;
  font-weight: normal;
  font-size: 14px;
  line-height: 30px;
`;

export default WordsLabel;


// WEBPACK FOOTER //
// ./src/elements/WordsLabel.tsx